import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

const PADDING = 2;

const SIZES = {
  small: { width: 25, height: 14 },
  medium: { width: 36, height: 20 },
};

const BG_COLOR_DEFAULT = '#9FA8BD';

const getThumbSize = (size) => SIZES[size].height - PADDING * 2;
const getThumbTranslateValue = (width) => (width - PADDING * 2) / 2;

const createSwitchBaseStyles = (size, theme) => ({
  padding: PADDING,

  '&$checked': {
    transform: `translateX(${getThumbTranslateValue(SIZES[size].width)}px)`,
    color: theme.palette.common.white,

    '& + $track': {
      backgroundColor: theme.palette.grey[600],
      borderColor: theme.palette.grey[600],
      opacity: 1,
    },
  },

  '&$disabled': {
    color: theme.palette.common.white,
  },

  '&:hover': {
    backgroundColor: 'transparent',
  },

  '&$focusVisible $thumb': {
    color: theme.palette.grey[600],
    border: '4px solid #fff',
  },
});

const createColorStyles = (switchBaseClass, palette, disabledColor) => ({
  [`&$${switchBaseClass}`]: {
    '&$checked': {
      '& + $track': {
        backgroundColor: palette.main,
        borderColor: palette.main,
      },

      '&$disabled': {
        '& + $track': {
          backgroundColor: disabledColor,
          borderColor: disabledColor,
        },
      },
    },

    '&$focusVisible $thumb': {
      color: palette.main,
    },
  },
});

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      width: ({ size }) => SIZES[size].width,
      height: ({ size }) => SIZES[size].height,
      padding: 0,
    },

    smallSwitchBase: createSwitchBaseStyles('small', theme),
    mediumSwitchBase: createSwitchBaseStyles('medium', theme),

    thumb: {
      width: ({ size }) => getThumbSize(size),
      height: ({ size }) => getThumbSize(size),
      boxShadow: 'none',
    },

    track: {
      borderRadius: ({ size }) => SIZES[size].height / 2,
      border: `2px solid ${BG_COLOR_DEFAULT}`,
      backgroundColor: BG_COLOR_DEFAULT,
      opacity: 0.5,
      transition: theme.transitions.create(['background-color', 'border']),
    },

    checked: {},
    focusVisible: {},
    disabled: {},

    colorPrimary: {
      ...createColorStyles('smallSwitchBase', theme.palette.primary, COLORS.primary.light),
      ...createColorStyles('mediumSwitchBase', theme.palette.primary, COLORS.primary.light),
    },

    colorSecondary: {
      ...createColorStyles('smallSwitchBase', theme.palette.secondary, null),
      ...createColorStyles('mediumSwitchBase', theme.palette.secondary, null),
    },
  }),
  { name: 'CustomSwitch' }
);
